import { get,put ,post} from "../../../../common/utils";
import * as RetailType from "../../actiontype/RetailType/RetailType";

export const getPharmacyRetail = (headers,showLoader,hideLoader,showToast,dataTrans) => (dispatch) => {

 dispatch({ type: RetailType.RETAIL_PHARMACY_REQUEST })
    showLoader();
    get(`/pharmacies`,headers)
      .then(res => {
        hideLoader();
        dispatch({ type: RetailType.RETAIL_PHARMACY_SUCCESS, payload: res.data })
      })
      .catch(err => {
        hideLoader();
        dispatch({ type: RetailType.RETAIL_PHARMACY_FAILURE, payload: err?.message })
        showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
      })
  }

export const getByRetailId = (id, showLoader, hideLoader, showToast, dataTrans) => (dispatch) => {
    showLoader();
    dispatch({ type: RetailType.RETAIL_REQUEST_GETBYID });
    get(`Pharmacy/${id}`)
      .then((res) => {
        dispatch({type: RetailType.RETAIL_SUCCESS_GETBYID,payload: res?.data});
        hideLoader();
        var headers = {
          pageNo: 1,
          pageSize: 10,
          pharmacyType: "retail",
          isCurrentUser:String(false)
        }
        dispatch(getPharmacyRetail(headers,showLoader,hideLoader,showToast,dataTrans))
      })
      .catch((err) => {
        hideLoader();
        dispatch({type: RetailType.RETAIL_FAILURE_GETBYID,payload: err?.response?.data?.message,});
        showToast("warn","Attenzione",dataTrans(err?.response?.data?.message));
      });
  };

  export const updateRetail = (id, payload, headers,showLoader,hideLoader,showToast,dataTrans,viewRoleId,setIsEditing) => (dispatch) => {
   
    showLoader();
    dispatch({ type: RetailType.RETAIL_REQUEST_UPDATE });
    put(`/Pharmacy/${id}`, payload, headers)
      .then((res) => {
        dispatch({
          type: RetailType.RETAIL_SUCCESS_UPDATE,
          payload: res.data,
        });
        hideLoader();
       
        setIsEditing(false)
        dispatch(getByRetailId(viewRoleId,showLoader,hideLoader,showToast, dataTrans));
        showToast('success',dataTrans('text_toast_success'),dataTrans(res?.response?.data?.message));
       
        console.log("check777")
        
      })
      .catch((err) => {
        console.log("check777")
        hideLoader();
        dispatch({type: RetailType.RETAIL_FAILURE_UPDATE,payload: err?.message,});
      });
  };

    export const updateStatusRetail = (id, payload, header, showLoader, hideLoader, showToast,dataTrans) => (dispatch) => {
      showLoader();
      dispatch({ type: RetailType.RETAIL_REQUEST_UPDATE })
      put(`/Pharmacy/UpdateStatus/${id}`, payload, header)
        .then(res => {
          hideLoader();
          dispatch({ type: RetailType.RETAIL_SUCCESS_UPDATE, payload: res.data })
          var headers = {
            pageNo: 1,
            pageSize: 10,
            pharmacyType: "retail",
            isCurrentUser:String(false)
          }
      
          showToast('success',dataTrans('text_toast_success'),dataTrans(res?.response?.data?.message));
          dispatch(getPharmacyRetail(headers, showLoader, hideLoader,showToast,dataTrans));
          // dispatch(getByPatientId(id, showLoader, hideLoader))
         
        })
        .catch(err => {
          hideLoader();
          dispatch({ type: RetailType.RETAIL_FAILURE_UPDATE, payload: err?.message })
          showToast('warn','Attenzione',dataTrans(err?.response?.data?.message));
        })
    }

    export const createHospitalRetail = (payload, showLoader, hideLoader, setIsSuccess, showToast, dataTrans) => (dispatch) => {
      showLoader();
      dispatch({ type: RetailType.RETAIL_REQUEST_CREATE })
      post('/Pharmacy', payload)
        .then(res => {
          dispatch({ type: RetailType.RETAIL_SUCCESS_CREATE, payload: res })
          setIsSuccess(true);
          hideLoader();
          var headers = {
            pageNo: 1,
            pageSize: 10,
            pharmacyType: "retail",
            isCurrentUser:String(false)
          }
          dispatch(getPharmacyRetail(headers, showLoader, hideLoader,showToast,dataTrans));
          showToast('success', dataTrans('text_toast_success'), dataTrans(res?.response?.data?.message));
        })
        .catch(err => {
          hideLoader();
          dispatch({ type: RetailType.RETAIL_FAILURE_CREATE, payload: err?.response?.data?.message })
          showToast('warn', 'Attenzione', dataTrans(err?.response?.data?.message));
        })
    }